import type { SvgProps } from '@/types/svgs/svg-types';

const SiteWideJackpotBolt = ({ width, height, fill }: SvgProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.6594 7.72359C12.5736 7.53299 12.3851 7.41122 12.1765 7.41122H7.58418L9.50922 0.67464C9.57699 0.436393 9.4711 0.183321 9.25509 0.0647264C9.03908 -0.052809 8.768 -0.00727724 8.60494 0.176968L0.133915 9.70687C-0.00479824 9.86252 -0.0386823 10.0849 0.0460279 10.2755C0.130738 10.4661 0.320277 10.5879 0.528876 10.5879H5.12123L3.19619 17.3244C3.12842 17.5627 3.23431 17.8158 3.45032 17.9343C3.53079 17.9778 3.61868 18 3.70551 18C3.85269 18 3.99776 17.9386 4.10153 17.8221L12.5726 8.29221C12.7102 8.13655 12.7451 7.91419 12.6594 7.72359Z"
                fill={fill}
            />
        </svg>
    );
};

export default SiteWideJackpotBolt;
